import React from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import { motion, AnimatePresence } from 'framer-motion';

// Components
import Navbar from './com/Navbar';
import Home from './com/Home';
import About from './com/About';
import Contact from './com/Contact';
import Services from './com/Services';
import Partnership from './com/Partnership';

// Page Wrapper for smooth transitions
const PageWrapper = ({ children }) => (
  <motion.div
    initial={{ opacity: 0, y: 10 }}
    animate={{ opacity: 1, y: 0 }}
    exit={{ opacity: 0, y: -10 }}
    transition={{ duration: 0.4, ease: "easeOut" }}
  >
    {children}
  </motion.div>
);

const AnimatedRoutes = () => {
  const location = useLocation();
  
  return (
    <AnimatePresence mode="wait">
      <Routes location={location} key={location.pathname}>
        <Route path="/" element={<PageWrapper><Home /></PageWrapper>} />
        <Route path="/about" element={<PageWrapper><About /></PageWrapper>} />
        <Route path="/contact" element={<PageWrapper><Contact /></PageWrapper>} />
        <Route path="/services" element={<PageWrapper><Services /></PageWrapper>} />
        <Route path="/partnership" element={<PageWrapper><Partnership /></PageWrapper>} />
      </Routes>
    </AnimatePresence>
  );
};

const App = () => {
  return (
    <Router>
      <div className="min-h-screen flex flex-col bg-white">
        <Navbar />
        
        {/* Spacer to push content below fixed navbar */}
        <div className="h-20"></div>

        <main className="flex-grow">
          <AnimatedRoutes />
        </main>

        <footer className="bg-[#032B53] text-white pt-20 pb-10">
          <div className="max-w-7xl mx-auto px-6">
            <div className="grid grid-cols-1 md:grid-cols-3 gap-12 pb-16">
              <div>
                <h3 className="text-2xl font-black mb-6 uppercase tracking-tighter">
                  ucorier <span className="text-[#0099FF]">kft</span>
                </h3>
                <p className="text-white/60 leading-relaxed max-w-xs font-medium">
                  Professional bike delivery infrastructure for Budapest's leading restaurants, shops, and hospitality sectors.
                </p>
              </div>
              
              <div>
                <h4 className="text-[#0099FF] text-xs font-bold uppercase tracking-[0.2em] mb-6">Contact Details</h4>
                <div className="space-y-4 text-white/80 font-medium">
                  <p className="hover:text-[#0099FF] transition-colors">contact@ucorierkft.com</p>
                  <p className="text-xl">+36 20 226 6679</p>
                </div>
              </div>

              <div>
                <h4 className="text-[#0099FF] text-xs font-bold uppercase tracking-[0.2em] mb-6">Headquarters</h4>
                <p className="text-white/80 font-medium leading-relaxed">
                  1146 Budapest, Thököly út 45.<br />
                  1. lház. alagsor 1. ajtó
                </p>
              </div>
            </div>

            <div className="pt-8 border-t border-white/10 flex flex-col md:flex-row justify-between items-center gap-6">
              <p className="text-white/40 text-[10px] font-bold uppercase tracking-widest">
                © {new Date().getFullYear()} UCORIER KFT. BUDAPEST, HUNGARY.
              </p>
              <div className="flex items-center space-x-2 text-[10px] font-bold uppercase tracking-widest text-white/40">
                <span>Designed by</span>
                <a href="https://betapixelstudio.com" className="text-[#0099FF] hover:underline">Beta Pixel Studio</a>
              </div>
            </div>
          </div>
        </footer>
      </div>
    </Router>
  );
};

export default App;